import React, { useEffect, useState } from "react";

import NavBarBackOffice from "./NavBarBackOffice";
import SideBarBackoffice from "./SideBarBackoffice";
import iconeCloseWindow from "../assets/IconeSvg/close_window.svg";
import Footer from "./Footer";
import { Snackbar } from "@mui/material";
import { ThreeDots } from "react-loader-spinner";
import { jwtDecode } from "jwt-decode";
import {
  ForgetPasswordUser,
  resetPasswordUser
} from "../services/auth/AuthenfiticationUsers";

const LayoutBackOffice = ({ children }) => {
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [snackbarErrorOpen, setSnackbarOpenError] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [connectedUser, setConnectedUser] = useState(null);
  const [tokenUser, setTokenUser] = useState(null);

  const [updateLoading, setUpdateLoading] = useState(false);

  const [snackbarPosition, setSnackbarPosition] = useState({
    vertical: "bottom",
    horizontal: "center"
  });
  const { vertical, horizontal } = snackbarPosition;

  const handleCloseSnackbarError = () => {
    setSnackbarOpenError(false);
  };

  const ChangePasswordUser = (user) => {
    setUpdateLoading(true);

    const data = {
      email: connectedUser.email,
      newPassword: newPassword,
      confirmNewPassword: confirmNewPassword
    };

    ForgetPasswordUser(data)
      .then((res) => {
        setUpdateLoading(false);
        // setSuccessMessage(`${res.response.message}`);
        setSuccessMessage("Mot de passe modifié avec succès");
        setSnackbarPosition({ vertical: "bottom", horizontal: "center" });
        setSnackbarOpenError(false);
        document.getElementById("update-password").close();
      })
      .catch((err) => {
        setUpdateLoading(false);
        console.log("err :", err);
        setErrorMessage(`Erreur ${err.response.data.message} `);
        setSnackbarPosition({ vertical: "bottom", horizontal: "center" });
        setSnackbarOpenError(true);
      });
  };

  useEffect(() => {
    const token = localStorage.getItem("compte_admin");
    const decoded = token ? jwtDecode(token) : null;

    setTokenUser(token);
    setConnectedUser(decoded);
  }, []);

  console.log("connecteedUser: ", connectedUser);
  console.log("token :", tokenUser);

  return (
    <div className="min-h-screen w-full flex flex-col gap-x-3 relative bg-gray-100 pb-[1rem] pt-[4rem]   ">
      {/* Barre de nativation fixed */}
      <div className="fixed top-0 z-50 w-full">
      <NavBarBackOffice />
      </div>

      {/* Contenu */}
      <div className="flex lg:flex-row md:flex-row flex-col justify-start gap-x-3 mt-5  w-full lg:px-14 ">
        <SideBarBackoffice   />
        <div className="flex flex-col w-full py-4 overscroll-auto bg-white rounded-2xl  shadow-lg ">
          {children}
        </div>
      </div>

      {/* Pied de page */}
      {/* <Footer /> */}

      {/* MODAL MIS A JOUR DU MOT PASSE */}
      <dialog id="update-password" className="modal">
        <div className="modal-box rounded-lg max-w-md p-4">
          <form method="dialog">
            <button
              disabled={updateLoading}
              className="w-8 h-8 absolute right-2 top-2"
            >
              <img
                src={iconeCloseWindow}
                className="cursor-pointer w-full"
                alt=""
              />
            </button>
          </form>
          <h3 className="font-extrabold text-xl text-left text-black">
            Modifier mon mot de passe
          </h3>
          <div className="py-4">
            <div>
              <label className="form-control w-full">
                <div className="label">
                  <span className="label-text font-bold text-gray-500 text-sm">
                    Email
                  </span>
                </div>
                <input
                  type="text"
                  disabled
                  value={connectedUser?.email}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Entrer votre ancien mot de passe"
                  className="input input-bordered w-full h-10 font-medium bg-[#F9F9F9]"
                />
              </label>
            </div>

            <div>
              <label className="form-control w-full">
                <div className="label">
                  <span className="label-text font-bold text-gray-500 text-sm">
                    Nouveau mot de passe
                  </span>
                </div>
                <input
                  type="text"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  disabled={updateLoading}
                  placeholder="Entrer votre nouveau mot de passe"
                  className="input input-bordered w-full h-10 font-medium bg-[#F9F9F9]"
                />
              </label>
            </div>
            <div>
              <label className="form-control w-full">
                <div className="label">
                  <span className="label-text font-bold text-gray-500 text-sm">
                    Confirmer le nouveau mot de passe
                  </span>
                </div>
                <input
                  type="text"
                  value={confirmNewPassword}
                  onChange={(e) => setConfirmNewPassword(e.target.value)}
                  disabled={updateLoading}
                  placeholder="Entrer votre ancien mot de passe"
                  className="input input-bordered w-full h-10 font-medium bg-[#F9F9F9]"
                />
              </label>
            </div>
          </div>
          <div className="modal-action flex justify-center">
            <form
              method="dialog"
              className="w-full flex flex-col sm:flex-row justify-center gap-x-3"
            >
              {/* if there is a button in form, it will close the modal */}
              {updateLoading ? (
                <div
                  disabled={updateLoading}
                  className="w-full h-10 bg-gray-300 text-gray-700 text-sm rounded-lg flex items-center justify-center font-semibold"
                >
                  Annuler
                </div>
              ) : (
                <button
                  disabled={updateLoading}
                  className="w-full h-10 bg-gray-300 text-gray-700 text-sm rounded-lg flex items-center justify-center font-semibold"
                >
                  Annuler
                </button>
              )}
              <div
                onClick={ChangePasswordUser}
                disabled={updateLoading}
                className="mt-2 sm:mt-0 w-full px-2 h-10 bg-primary text-white text-sm rounded-lg flex items-center justify-center font-semibold cursor-pointer"
              >
                {!updateLoading ? (
                  "Modifier"
                ) : (
                  <ThreeDots
                    height="40"
                    width="40"
                    radius="9"
                    color="#fff"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={updateLoading}
                  />
                )}
              </div>
            </form>
          </div>
        </div>
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={snackbarErrorOpen}
          autoHideDuration={2000}
          onClose={handleCloseSnackbarError}
          key={vertical + horizontal}
          className="z-[999999]"
        >
          <div
            className={`${
              errorMessage ? "bg-red-600" : successMessage ? "bg-green-600" : ""
            } text-white font-bold z-[999999] px-10 py-3 rounded-lg`}
          >
            {errorMessage && errorMessage}
            {successMessage && successMessage}
          </div>
        </Snackbar>
      </dialog>
    </div>
  );
};

export default LayoutBackOffice;
